<template>
    <b-modal centered title="Bienvenido a Kllaar"
             hide-footer
             hide-header
             v-model="modal"
    no-close-on-backdrop
    no-close-on-esc>
        <div class="row">
        <div class="col-md-12 text-center p-5">
            <img src="@/assets/b_logo.png" height="50">
            <br><br>
            <h4 class="font-blue">¡Listo!</h4>
            <p class="font-gray-dark">
                ¡Gracias por registrarte en Kllaar.com!
                <br>
                <br>
                A continuación, recibirás un mensaje en el E-mail que nos proporcionaste. Recuerda revisar la bandeja
                de correo no deseado para asegurarte de que lo hayas recibido. <br>
                Por favor valida tu correo electrónico ¡y accede una vez más!
                <br>
                <br>
                Te recomendamos completar tu perfil de usuario para que puedas disfrutar de más beneficios en Kllaar.com
            </p>

            <div class="__inforesend b-green my-3 p-2 rounded" v-if="email">
                Se ha enviado tu código de confirmación <br>
                {{ email }}
            </div>

            <b-button type="button" :disabled="loading" @click="sendEmail" class="b-orange btn-block mt-4">
                <b-spinner v-if="loading" small label="Espere ..."></b-spinner>
                Reenviar E-Mail
            </b-button>

            <b-button type="button" @click="logout()" class="btn-secondary  btn-block">Cerrar sesion</b-button>
        </div>
        </div>
    </b-modal>
</template>
<script>
export default {
    name: 'WelcomeModal',
    data() {
        return {
            modal: true,
            loading: false,
            resendCode: false,
            email: ''
        }
    },
    methods:{
        logout() {
            this.$store.dispatch('logout')
                .then(() => {
                    this.$router.push('/login')
                })
        },
        sendEmail(){
            this.loading = true
            this.api.post('auth/token/resend').then(({data}) => {
                this.resendCode = true
                this.loading = false
                this.email = data.data.user.email
                this.toast(data.data.message)
            }).catch(err => {
                this.loading = false
            })
        },
        toast(message){
            this.$bvToast.toast(message, {
                title: "Kllaar.com",
                variant: 'success',
                toaster: 'b-toaster-bottom-right',
                solid: true,
                appendToast: true
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/#pages/#auth/activation/WelcomeModal.vue